import React from 'react';

export default function ScanHistory({ history, onItemClick }) {
  if (!history || history.length === 0) return null;

  const getScoreClass = (score) => {
    if (score >= 70) return 'safe';
    if (score >= 40) return 'warning';
    return 'danger';
  };

  return (
    <div className="history-section">
      <div className="history-title">🕐 Histórico de Análises</div>
      <div className="history-list">
        {history.map((item, i) => (
          <div
            key={i}
            className="history-item"
            onClick={() => onItemClick(item.url)}
          >
            <span className="url-protocol" style={{ fontSize: '12px' }}>
              {item.classification === 'safe' ? '✅' : item.classification === 'warning' ? '⚠️' : '🚨'}
            </span>
            <span className="history-url">{item.url}</span>
            <span className={`history-score ${getScoreClass(item.score)}`}>
              {item.score}/100
            </span>
            <span className="history-time">{item.timestamp}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
